<script>

import VJsoneditor from 'v-jsoneditor/src/index'

import ActionTemplates from './ActionTemplates'
import InputOutputForm from './InputOutputForm'
import ModalCard from './ModalCard'
import JSONEditor from './JSONEditor'
import Traits from './Traits'

const matchAll = require('string.prototype.matchall')


export default {
  components: {
    InputOutputForm,
    JSONEditor,
    VJsoneditor,
    ModalCard,
    Traits
  },

  data() {
    return {
      useJsonEditor: false,
      model: Object.assign({}, this.actionTemplate.$data)
    }
  },

  watch: {
    actionTemplate() {
      this.model = Object.assign({}, this.actionTemplate.$data)
    },

    'model.endpoint' () {
      this.model.pathParams = [...matchAll(this.model.endpoint, /{(.*?)}/g)].map((regexResult)=>{
        return regexResult[1]
      })
    }
  },

  methods: {
    saveActionTemplate() {
      if (!this.model.name || !this.model.endpoint || !this.model.method) {
        return
      }
      ActionTemplates.storage.save(this.model)
      this.$emit('save')
    }
  },

  props: {
    actionTemplate: {
      type: Object,
      required: true
    }
  },

  computed: {
    isNewRecord(){
      return !(this.actionTemplate && this.actionTemplate.uuid)
    },
    title() {
      if(this.isNewRecord) {
        return "New Action Template"
      }
      return `Edit Template "${this.actionTemplate.name}"`
    }
  }
}
</script>

<template>
  <modal-card :title="title">

    <template slot="body">
      <transition name="editor">
        <section key="json" v-if="useJsonEditor">
          <div class="modal-card-body">
            <JSONEditor @cancel="useJsonEditor = false" v-model="model"></JSONEditor>
          </div>
        </section>
        <section key="form" v-else>
          <b-field horizontal label="Name" message="Give your template a descriptive name">
            <b-input placeholder="Create Provider" v-model="model.name"></b-input>
          </b-field>


          <br>
          <b-field horizontal>
            <p>Every template can only include a single HTTP request. You can connect them later within a workflow.</p>
          </b-field>

          <b-field horizontal label="HTTP Verb">
            <b-select v-model="model.method">
              <option value="POST">POST</option>
              <option value="GET">GET</option>
              <option value="PUT">PUT</option>
              <option value="DELETE">DELETE</option>
              <option value="PATCH">PATCH</option>
            </b-select>
          </b-field>

          <b-field horizontal label="Wait after completion (ms)">
            <b-numberinput :min="0" :step="500" :max="5000" v-model="model.timeout"></b-numberinput>
          </b-field>

          <b-field horizontal label="Endpoint" message="JSON endpoint path. You can reference inputs in the path like this: {provider_id}">
            <b-input placeholder="/pl/0/providers.json" v-model="model.endpoint"></b-input>
          </b-field>

          <hr>

          <b-field horizontal label="Default parameters">
            <v-jsoneditor v-model="model.defaults" :plus="false" height="200px">
            </v-jsoneditor>
          </b-field>
          <hr>

          <b-field horizontal label="Traits">
            <traits v-model="model.traits">
            </traits>
          </b-field>
          <hr>

          <input-output-form v-model="model.output" label="Outputs"
            :left="{label: 'Internal name', message: 'Only used to reference parameters between actions.', placeholder: 'my_car_license'}"
            :right="{label: 'JSON Keys', message: 'Nested path to the desired output. Should be in dot notation as well.', placeholder: 'car.license'}"
          ></input-output-form>
          <hr>
          <input-output-form v-model="model.input" label="Required Input"
            :left="{label: 'Internal name', message: 'Only used to reference parameters between actions.', placeholder: 'my_provider_id'}"
            :right="{label: 'Parameter name', message: 'Nested parameter name in dot notation.', placeholder: 'car.provider_id'}"
            :readOnlyData="model.pathParams"
          ></input-output-form>

        </section>
      </transition>
    </template>

    <template slot="footer">
      <b-button @click="useJsonEditor = !useJsonEditor" size="is-small" :type="{'is-primary': useJsonEditor}" icon-left="code-braces">
        Toggle JSON-View
      </b-button>
      <div>
        <b-button :disabled="useJsonEditor" type="is-text" @click="$emit('cancel')">Cancel</b-button>
        <b-button :disabled="useJsonEditor" type="is-primary" @click="saveActionTemplate">Save</b-button>
      </div>
    </template>

  </modal-card>

</template>

<style lang="scss">
.editor-leave-active {
  display: none;
}
.editor-enter-active, .editor-leave-active {
  transition: all .4s ease-out;
}

.editor-enter, .editor-leave-to{
  opacity: 0;
}

</style>